import Modal from '@components/ui/Modal'
import Notification from '@components/ui/Notification'
import styles from './styles.module.scss'
import { Button } from '@components/ui/Button'
import { useAuth } from '@api/accounts/auth/hooks/useAuth'
import { useRouter } from 'next/router'
import { prefixLocale } from '@helpers/env'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { useEffect, useRef, useState } from 'react'
import { analytics } from '@helpers/analytics'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'

function ErrorModal() {
  const { errorMessage } = useAuth()
  const { login } = useLogin()
  const [selected, setSelected] = useState(false)
  const router = useRouter()

  const handleLoginClick = () => {
    if (!selected) {
      setSelected(true)
      login()
    }
  }

  const hasFiredViewEvent = useRef(false)
  useEffect(() => {
    // Fire the "viewed" analytics event once when the modal mounts.
    if (hasFiredViewEvent.current) return
    hasFiredViewEvent.current = true

    analytics('Account Page Error Modal Viewed', {
      action: 'Error Modal',
      message: errorMessage,
      category: 'Account'
    })
  }, [errorMessage])

  return (
    <Modal openedModal={true}>
      <div className={styles.accountModal}>
        <h1>Website, we have a problem.</h1>
        <Notification type="error" content={errorMessage} />
        <div className={styles.buttonsWrapper}>
          <Button variant="primary" onClick={handleLoginClick}>
            Login
          </Button>
          <ButtonMinimal
            classes={styles.homeButton}
            onClick={() => router.push(`${prefixLocale()}/`)}
            underlined={true}
          >
            Continue shopping
          </ButtonMinimal>
        </div>
      </div>
    </Modal>
  )
}

export default ErrorModal
